<template>
  <div>
    <PageBanner :obj="obj"></PageBanner>
    <router-view></router-view>
  </div>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "CASES",
        en: "CLASSIC CASES",
        link: "/case",
        image: "",
        list: [],
      },
    };
  },
  methods: {
    async casesIndex() {
      let res = await service.casesIndex();
      if (res.code == 1) {
        this.obj.cn = res.data.banner.name;
        this.obj.en = res.data.banner.eng_title;
        this.obj.image = this.$baseURL + res.data.banner.thumb;
        this.obj.list = res.data.catlist.map((item, index) => {
          return { id: item.id, cat_name: item.title, comp: "/case/list" };
        });
      }
    },
  },
  created() {
    this.casesIndex();
  },
};
</script>

<style></style>